import React from 'react'
import { useStore } from '../store/store';
import Star from '../assets/star.svg'
import ProductImage from '../assets/productImg.png'
import { Link } from 'react-router-dom';

const AllProducts = () => {
    const { state: { products } } = useStore();

    return (
        <div className='bg-white md:py-[100px] p-10 w-full'>
            <div className='capitalize text-[clamp(1.8rem,4vw,2.5rem)] font-[600] leading-[clamp(2rem,5vw,3.125rem)]'>
                <span className='text-black'>Customer </span>
                <span className='text-primary'>favourites </span>
            </div>
            <div className='mt-[50px] flex items-center flex-wrap justify-center gap-y-[50px] gap-x-[100px]'>
                {
                    products.length ? products.map(product => {
                        return (
                            <div key={product.productId} className='flex flex-col items-center justify-center px-4 rounded-xl'>
                                <img src={ProductImage} alt={product.productName} className='w-[198px]' />
                                <div className='w-full flex items-center flex-wrap gap-x-10 justify-center mt-[30px]'>
                                    <p className='text-[24px] font-[600] leading-[normal] capitalize'>{product.productName.replaceAll('_', ' ')}</p>
                                    <p className='text-[20px] font-[600] leading-[normal] text-secondary'>{product.productQty} Bottles</p>
                                </div>
                                <div className='my-[17px] flex gap-2 items-center justify-center h-6'>
                                    <div className='flex gap-[3px]'>
                                        <img src={Star} alt="Star" />
                                        <img src={Star} alt="Star" />
                                        <img src={Star} alt="Star" />
                                        <img src={Star} alt="Star" />
                                        <img src={Star} alt="Star" />
                                    </div>
                                    <p className='text-[16px] font-[400] leading-[normal] text-secondary'>5 Out of 5 Rating</p>
                                </div>
                                <p className='text-[24px] font-[600] leading-[normal] mb-5'>${product.price}</p>
                                <Link to={`/${product.productName.replaceAll('_', '-')}`} className='btn-primary flex items-center'>Learn More</Link>
                            </div>
                        )
                    }) : <div className='flex items-center flex-wrap justify-center gap-y-[30px] gap-x-[100px]'>
                        <div className="w-[380px] p-4 bg-white rounded-lg shadow-md space-y-4">
                            <div className="w-full h-72 bg-gray-300 rounded-md animate-pulse"></div>
                            <div className="w-2/3 h-5 bg-gray-300 rounded-md animate-pulse"></div>
                            <div className="w-full h-4 bg-gray-300 rounded-md animate-pulse"></div>
                            <div className="w-5/6 h-4 bg-gray-300 rounded-md animate-pulse"></div>
                            <div className="w-1/3 h-8 bg-gray-300 rounded-md animate-pulse"></div>
                        </div>
                        <div className="w-[380px] p-4 bg-white rounded-lg shadow-md space-y-4 hidden md:block">
                            <div className="w-full h-72 bg-gray-300 rounded-md animate-pulse"></div>
                            <div className="w-2/3 h-5 bg-gray-300 rounded-md animate-pulse"></div>
                            <div className="w-full h-4 bg-gray-300 rounded-md animate-pulse"></div>
                            <div className="w-5/6 h-4 bg-gray-300 rounded-md animate-pulse"></div>
                            <div className="w-1/3 h-8 bg-gray-300 rounded-md animate-pulse"></div>
                        </div>
                        <div className="w-[380px] p-4 bg-white rounded-lg shadow-md space-y-4">
                            <div className="w-full h-72 bg-gray-300 rounded-md animate-pulse"></div>
                            <div className="w-2/3 h-5 bg-gray-300 rounded-md animate-pulse"></div>
                            <div className="w-full h-4 bg-gray-300 rounded-md animate-pulse"></div>
                            <div className="w-5/6 h-4 bg-gray-300 rounded-md animate-pulse"></div>
                            <div className="w-1/3 h-8 bg-gray-300 rounded-md animate-pulse"></div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default AllProducts